import { z } from "zod";
import { quantitySchema, timestampSchema, uuidSchema } from "../common/primitives.js";
/**
 * Satış tahmini ve sipariş önerisi (Prompt 12 §9; ADR 0012 §14).
 *
 * Tahmin BASİT ve AÇIKLANABİLİRDİR: son `forecastWeeks` haftanın aynı **haftanın günü × saat** ortalaması
 * (7 × 24 tüketim profili, İstanbul saatine göre). Tahmini bitiş, kullanılabilir hacmin (son brüt okuma −
 * minimum seviye) profil saat saat ileri sarılarak tüketilmesidir.
 *
 * Sipariş önerisi ÜRÜN bazındadır: aynı ürünün tankları tek havuz sayılır (tanker hangi tanka boşaltılacağını
 * istasyon belirler). Öneri, tanker geldiğinde tanklara sığacak miktarı AŞMAYAN en büyük kompartıman
 * bileşimidir — taşma riski, eksik siparişten pahalıdır. Yolda olan (onaylı / iletilmiş ama teslim alınmamış)
 * sipariş miktarı önericiden DÜŞÜLÜR.
 */
export const ORDER_URGENCIES = ["URGENT", "SOON", "OK"];
export const orderUrgencySchema = z.enum(ORDER_URGENCIES);
export const ORDER_URGENCY_LABELS = {
    URGENT: "Acil",
    SOON: "Yaklaşıyor",
    OK: "Uygun",
};
export const orderSuggestionsQuerySchema = z.object({ stationId: uuidSchema });
export const orderSuggestionSchema = z.object({
    productId: uuidSchema,
    productName: z.string(),
    tankIds: z.array(uuidSchema),
    /** Σ nominal kapasite × güvenli doluluk %. */
    safeCapacityL: quantitySchema,
    /** Σ son brüt okuma (okuması olmayan tank 0 sayılır). */
    currentL: quantitySchema,
    /** Tüketim profilinden, teslim süresi (`leadTimeHours`) boyunca beklenen satış. */
    consumptionUntilDeliveryL: quantitySchema,
    /** Son `forecastWeeks` haftanın GÜNLÜK ortalaması. */
    dailyAverageL: quantitySchema,
    /** `minimumStockDays` × günlük ortalama — teslimden SONRA tankta kalması istenen miktar. */
    minimumTargetL: quantitySchema,
    maxReceivableL: quantitySchema,
    requiredL: quantitySchema,
    /** Yolda olan sipariş (APPROVED / SENT; teslim edilmemiş kalan). */
    pendingOrderL: quantitySchema,
    /** Bekleyen sipariş düşülmüş NİHAİ öneri. */
    suggestedL: quantitySchema,
    compartments: z.array(quantitySchema),
    belowTarget: z
        .boolean()
        .describe("Öneri minimum stok hedefini karşılamıyor (tank küçük / kompartıman büyük)"),
    /** Ürünün tanklarındaki EN ERKEN tahmini bitiş; 14 günlük ufukta bitmiyorsa null. */
    earliestRunOutAt: timestampSchema.nullable(),
    urgency: orderUrgencySchema,
    leadTimeHours: z.number().int().positive(),
});
export const orderSuggestionListSchema = z.object({
    stationId: uuidSchema,
    generatedAt: timestampSchema,
    /** Ayardaki tahmin penceresi — kullanıcıya "neye göre" bilgisini verir. */
    forecastWeeks: z.number().int().positive(),
    items: z.array(orderSuggestionSchema),
});
//# sourceMappingURL=forecast.js.map